// src/modules/treasury/constants/treasuryConstants.js

export const BRANCH_TYPE = {
  HO: 'HO',
  BRANCH: 'BRANCH',
};

export const PAYMENT_MODE = {
  CASH: 'CASH',
  BANK: 'BANK',
};

export const PAYMENT_MODE_OPTIONS = [
  { label: 'Cash', value: PAYMENT_MODE.CASH },
  { label: 'Bank Transfer', value: PAYMENT_MODE.BANK },
];

export const APPROVAL_STATUS = {
  PENDING: 'PENDING',
  AUTO_APPROVED: 'AUTO_APPROVED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const APPROVAL_STATUS_OPTIONS = [
  { label: 'Pending', value: APPROVAL_STATUS.PENDING, color: 'orange' },
  { label: 'Auto Approved', value: APPROVAL_STATUS.AUTO_APPROVED, color: 'green' },
  { label: 'Approved', value: APPROVAL_STATUS.APPROVED, color: 'green' },
  { label: 'Rejected', value: APPROVAL_STATUS.REJECTED, color: 'red' },
];

export const DAY_STATUS = Object.freeze({
  OPEN: 'OPEN',
  PENDING_CASH_VERIFICATION: 'PENDING_CASH_VERIFICATION',
  // Single generic "awaiting approval" status — who approves (Branch Manager,
  // HO, or any other configured step) is template-driven, not a fixed BM/HO
  // pair. See the linked ApprovalInstance's currentStepName for the stage.
  PENDING_CHECKER_APPROVAL: 'PENDING_CHECKER_APPROVAL',
  CLOSED: 'CLOSED',
  REOPENED: 'REOPENED',
  HOLIDAY_AUTO_CLOSED: 'HOLIDAY_AUTO_CLOSED',
});

export const DAY_STATUS_OPTIONS = [
  { label: 'Open', value: DAY_STATUS.OPEN, color: 'green' },
  { label: 'Pending Cash Verification', value: DAY_STATUS.PENDING_CASH_VERIFICATION, color: 'orange' },
  { label: 'Pending Approval', value: DAY_STATUS.PENDING_CHECKER_APPROVAL, color: 'blue' },
  { label: 'Closed', value: DAY_STATUS.CLOSED, color: 'default' },
  { label: 'Reopened', value: DAY_STATUS.REOPENED, color: 'magenta' },
  { label: 'Holiday Auto-Closed', value: DAY_STATUS.HOLIDAY_AUTO_CLOSED, color: 'purple' },
];

export const CASH_LEDGER_ENTRY_TYPE = {
  OPENING_BALANCE: 'OPENING_BALANCE',
  CASH_IN: 'CASH_IN',
  CASH_OUT: 'CASH_OUT',
  ADJUSTMENT: 'ADJUSTMENT',
  CLOSING_BALANCE: 'CLOSING_BALANCE',
};

export const TREASURY_MODULE = {
  WALK_IN: 'WALK_IN',
  PLEDGE_ADVANCE: 'PLEDGE_ADVANCE',
  PLEDGE_SETTLEMENT: 'PLEDGE_SETTLEMENT',
  MANUAL_ADJUSTMENT: 'MANUAL_ADJUSTMENT',
  BRANCH_FUNDING: 'BRANCH_FUNDING',
  INTER_BRANCH_TRANSFER: 'INTER_BRANCH_TRANSFER',
  EXPENSE: 'EXPENSE',
  EOD: 'EOD',
};

// Inter-Branch Cash Transfer (IBCT) status
export const INTER_BRANCH_TRANSFER_STATUS = {
  PENDING: 'PENDING',
  RECEIVED: 'RECEIVED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
};

export const INTER_BRANCH_TRANSFER_STATUS_OPTIONS = [
  { label: 'In Transit', value: INTER_BRANCH_TRANSFER_STATUS.PENDING, color: 'orange' },
  { label: 'Received', value: INTER_BRANCH_TRANSFER_STATUS.RECEIVED, color: 'green' },
  { label: 'Rejected', value: INTER_BRANCH_TRANSFER_STATUS.REJECTED, color: 'red' },
  { label: 'Cancelled', value: INTER_BRANCH_TRANSFER_STATUS.CANCELLED, color: 'default' },
];

// Rule threshold: cash payments at or below this are auto-approved
export const AUTO_APPROVAL_CASH_LIMIT = 20000;

// Indian currency denominations for EOD counting
export const DENOMINATION_NOTES = [
  { key: 'note2000', label: '₹2000', value: 2000 },
  { key: 'note500',  label: '₹500',  value: 500  },
  { key: 'note200',  label: '₹200',  value: 200  },
  { key: 'note100',  label: '₹100',  value: 100  },
  { key: 'note50',   label: '₹50',   value: 50   },
  { key: 'note20',   label: '₹20',   value: 20   },
  { key: 'note10',   label: '₹10',   value: 10   },
  { key: 'note5',    label: '₹5',    value: 5    },
  { key: 'note2',    label: '₹2',    value: 2    },
  { key: 'note1',    label: '₹1',    value: 1    },
];

// Permission module keys (mirrors backend PERMISSION_MODULES)
export const TREASURY_PERMISSION_MODULES = {
  TREASURY: 'treasury',
  CASH_LEDGER: 'treasuryCashLedger',
  APPROVALS: 'treasuryApprovals',
  CENTRAL_FUND: 'treasuryCentralFund',
  DAY_CLOSURE: 'treasuryDayClosure',
  HO_DASHBOARD: 'treasuryHoDashboard',
};

export const API_ENDPOINTS = {
  CASH_LEDGER: '/treasury/cash-ledger',
  CASH_LEDGER_BALANCE: '/treasury/cash-ledger/balance',
  COMBINED_LEDGER: '/treasury/combined-ledger',
  PAYMENT_REQUESTS: '/treasury/payment-requests',
  CENTRAL_FUND: '/treasury/central-fund',
  CENTRAL_FUND_BALANCE: '/treasury/central-fund/balance',
  CENTRAL_FUND_LOAD: '/treasury/central-fund/load',
  CENTRAL_FUND_FUND_BRANCH: '/treasury/central-fund/fund-branch',
  DAY_STATUS: '/treasury/day-status',
  EOD_INITIATE: '/treasury/eod/initiate',
  EOD_DENOMINATION: '/treasury/eod/denomination',
  EOD_SUBMIT: '/treasury/eod/submit',
  EOD_BLOCKING_DAYS: '/treasury/eod/blocking-days',
  EOD_FORCE_CLOSE: '/treasury/eod/force-close',
  EOD_FORCE_CLOSE_ALL: '/treasury/eod/force-close-all',
  HO_DASHBOARD_SUMMARY: '/treasury/ho-dashboard/summary',
  HO_DASHBOARD_BRANCHES: '/treasury/ho-dashboard/branches',
  CLOSURE_APPROVALS: '/treasury/closure-approvals',
  BRANCH_OVERRIDES: '/treasury/branch-overrides',
  TRANSFERS: '/treasury/transfers',
};
